module.exports = __webpack_public_path__ + "static/media/Revival_filling up posts 5 years MoF.fa3c1100.fa3c1100.pdf";